/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SkinToneFromJSON, SkinToneToJSON, } from './SkinTone';
import { InternalCommonUserBaseFromJSON, InternalCommonUserBaseToJSON, } from './InternalCommonUserBase';
/**
 * Check if a given object implements the InternalUserReactionsEmojiSummaryResponseV3EmojisInner interface.
 */
export function instanceOfInternalUserReactionsEmojiSummaryResponseV3EmojisInner(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('user' in value) || value['user'] === undefined)
        return false;
    if (!('unicode' in value) || value['unicode'] === undefined)
        return false;
    if (!('skinTone' in value) || value['skinTone'] === undefined)
        return false;
    return true;
}
export function InternalUserReactionsEmojiSummaryResponseV3EmojisInnerFromJSON(json) {
    return InternalUserReactionsEmojiSummaryResponseV3EmojisInnerFromJSONTyped(json, false);
}
export function InternalUserReactionsEmojiSummaryResponseV3EmojisInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': (new Date(json['created_at'])),
        'user': InternalCommonUserBaseFromJSON(json['user']),
        'unicode': json['unicode'],
        'skinTone': SkinToneFromJSON(json['skin_tone']),
    };
}
export function InternalUserReactionsEmojiSummaryResponseV3EmojisInnerToJSON(json) {
    return InternalUserReactionsEmojiSummaryResponseV3EmojisInnerToJSONTyped(json, false);
}
export function InternalUserReactionsEmojiSummaryResponseV3EmojisInnerToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'created_at': ((value['createdAt']).toISOString()),
        'user': InternalCommonUserBaseToJSON(value['user']),
        'unicode': value['unicode'],
        'skin_tone': SkinToneToJSON(value['skinTone']),
    };
}
